export const BLOCKCHAIN_SUPPORT = 'blockchain_support';
export const WALLET_SUPPORT = 'wallet_support';